import { useContext } from 'react';

import type { WorkflowContextType } from '@/types/workflow.types';
import { WorkflowContext } from '@/utils/workflowContext';

/**
 * Custom hook to access the WorkflowContext
 * @returns {WorkflowContextType | null} The workflow context value
 */
export const useWorkflowContext = (): WorkflowContextType | null => {
  const context = useContext(WorkflowContext);
  return context;
};
